export default __webpack_public_path__ + "assets/unswg_keydates_aem_applied_degrees.csv?143cc7c028e7ad4bb88a5051f25540a9";